import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Typography } from "@material-ui/core"
import { AddToCart, Button, RichDescription, RichTitle } from ".."
import leafLeft from "../../puraearth/src/images/leaf left.png"
import leafRight from "../../puraearth/src/images/leaf right.png"
import { navigate } from "../../puraearth/.cache/gatsby-browser-entry"
import { Link } from "gatsby"
import Img from "gatsby-image"

const useStyles = makeStyles(theme => {
  return {
    root: props => ({
      alignItems: "center",
      color: theme.palette[props.color].main,
      display: "flex",
      flexDirection: "column",
      paddingBottom: theme.spacing(0.5),
      position: "relative",
      zIndex: 0,
      flex: "1 1 33%",
      margin: theme.spacing(0, 2),
      maxWidth: theme.spacing(40),
      [theme.breakpoints.up("md")]: {
        minHeight: theme.spacing(55),
      },
      [theme.breakpoints.only("md")]: {
        maxWidth: theme.spacing(37.5),
        margin: theme.spacing(5),
      },
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(2),
      },
    }),
    singleProductRoot: props => ({
      alignItems: "center",
      color: theme.palette[props.color].main,
      display: "flex",
      flexDirection: "column",
      paddingBottom: theme.spacing(0.5),
      position: "relative",
      zIndex: 0,
      flex: "1 1 33%",
      margin: theme.spacing(0, 2, 4),
      maxWidth: theme.spacing(36),
      [theme.breakpoints.up("md")]: {
        minHeight: theme.spacing(65),
      },
      [theme.breakpoints.only("md")]: {
        maxWidth: theme.spacing(37.5),
        margin: theme.spacing(5),
      },
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(2),
      },
    }),

    rootBg: props => ({
      backgroundImage: `url('${leafLeft}'), url('${leafRight}')`,
      backgroundPosition: "left 9rem, right 2rem",
      backgroundRepeat: "no-repeat",
      backgroundSize: "20%",
      border: "4px solid",
      borderColor:
        props.color === "black"
          ? theme.palette.gray.main
          : theme.palette[props.color].support,
      height: "100%",
      opacity: 0,
      position: "absolute",
      transition: "opacity 0.5s ease-in-out",
      width: "100%",
      zIndex: 1,
      "&:hover": {
        opacity: 1,
      },
      [theme.breakpoints.down("md")]: {
        backgroundPosition: "left 9rem, right 2rem",
      },
    }),
    productName: {
      margin: theme.spacing(5, 0),
      fontWeight: "normal",
      textAlign: "center",
      maxWidth: "70%",
    },
    productTitle: {
      margin: theme.spacing(3, 0, 0, 0),
      fontWeight: "normal",
      fontSize: "20px",
      textAlign: "center",
      maxWidth: "70%",
    },
    productPrice: {
      margin: theme.spacing(1, 0, 3, 0),
      fontWeight: "normal",
      fontSize: "16px",
      textAlign: "center",
    },
    productImage: {
      maxWidth: "100%",
    },
    button: {
      zIndex: 3,
    },
    singleProductButton: properties => ({
      zIndex: 3,
      backgroundColor: "white",
      color: theme.palette[properties.color].main,
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(2, 2, 3, 0),
      },
    }),
    buttonWrapper: {
      display: "flex",
      flexDirection: "row",
      justifySelf: "center",
      [theme.breakpoints.up("md")]: {
        position: "absolute",
        padding: theme.spacing(0, 2),
        bottom: theme.spacing(3),
      },
      "text-align": "center",
    },
    link: {
      textDecoration: "none",
      [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(6),
      },
    },
    addToCart: {
      [theme.breakpoints.down("md")]: {
        display: "block",
      },
      zIndex: 3,
    },
    'button[data-cy="add-cart-button"]': {
      display: "block",
    },
    price_wrapper: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "flex-start",
    },
    out_of_stock: {
      margin: "9px 0px 24px 10px",
      color: theme.palette["red"].main,
      textTransform: "uppercase",
      height:"90px",
    },
  }
})

export default props => {
  const properties = {
    color: props.color,
  }
  const classes = useStyles(properties)

  return (
    <div
      className={
        props.isSingleProduct ? classes.singleProductRoot : classes.root
      }
    >
      {props.productPage ? (
        <img className={classes.productImage} src={props.productImage} alt="" />
      ) : (
        <Img
          className={classes.productImage}
          fixed={props.productImage}
          alt=""
        />
      )}
      <Typography
        variant={"h4"}
        component={"div"}
        className={
          props.productTitle === "" ? classes.productName : classes.productTitle
        }
      >
        {props.productName && props.productName.content ? (
          <RichTitle titleText={props.productName} />
        ) : (
          props.productName
        )}
      </Typography>

      {props.productPrice !== "" && props.langKey === "es" && (
        <div className={classes.price_wrapper}>
          <Typography
            variant={"h6"}
            component={"div"}
            className={classes.productPrice}
          >
            {props.productPrice}
          </Typography>
          {props.isOutOfStock && (
            <Typography
              classes={{ root: classes.out_of_stock }}
              variant={"span"}
              component={"span"}
            >
              {props.outOfStock}
            </Typography>
          )}
        </div>
      )}

      {props.langKey === "es" &&
      <div className={classes.buttonWrapper}>
        <Button
          onClick={event => {
            event.preventDefault()
            navigate(props.productLink ? props.productLink : props.slug)
          }}
          data-cy="discover"
          color={props.color}
          className={
            props.isSingleProduct ? classes.singleProductButton : classes.button
          }
        >
          {props.buttonText && props.buttonText.content ? (
            <RichDescription copyText={props.buttonText} />
          ) : (
            props.buttonText
          )}
        </Button>

        {props.productTitle !== "" && (
          <AddToCart
            isDisabled={props.isOutOfStock || props.isComingSoon}
            addedClass="block-on-mobile"
            cartType="simple"
            color={props.color}
            itemId={props.itemId}
            langKey={props.langKey}
          />
        )}
      </div>
      }
      <Link
        className={classes.rootBg}
        to={props.productLink ? props.productLink : props.slug}
      />
    </div>
  )
}
